import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Select,
  Stack,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";


import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import PermissionTables from "./PermissionTable";
import PermissionLogTable from "./PermissionLogTable";
import TemplateTable from "./TemplateTable";


const guardrailRows = [
  {
    id: 1,
    name: "High-Value Item Verification",
    desc: "Require manual approval for orders over AED 2,500.",
    modules: ["Luxury & Jewelry"],
    severity: "Critical",
    autopilot: "Locked",
  },
  {
    id: 2,
    name: "New Seller Restrictions",
    desc: "Require human review for actions from vendors under 30 days.",
    modules: ["Boutique Core"],
    severity: "Moderate",
    autopilot: "Locked",
  },
  {
    id: 3,
    name: "Price Change Monitoring",
    desc: "Flag price changes over 20% within 24 hours.",
    modules: ["Pricing Engine"],
    severity: "Moderate",
    autopilot: "ON",
  },
  {
    id: 4,
    name: "Profanity & Inappropriate Content",
    desc: "Automatically restrict listings with banned words.",
    modules: ["Listings"],
    severity: "Moderate",
    autopilot: "ON",
  },
  {
    id: 5,
    name: "Approvals for Healthcare Products",
    desc: "Require admin approval for any product listed in Healthcare.",
    modules: ["Groceries"],
    severity: "Moderate",
    autopilot: "OFF",
  },
];


const maturityLevels = [
  {
    id: 1,
    level: "Level 1",
    title: "Recommend Only.",
    desc: "AI suggests actions only. Admin approval required to execute.",
  },
  {
    id: 2,
    level: "Level 2",
    title: "Recommend + Execute",
    desc: "AI recommends and auto-executes actions requiring medium oversight.",
  },
  {
    id: 3,
    level: "Level 3",
    title: "Fully Autonomous",
    desc: "AI acts independently. Alerts Admin and allows fallback.",
  },
];

const logs = [
  {
    id: 1,
    text: "Grow tier set to Recommend + Execute",
    date: "3 days ago",
    user: "Jane Doe",
  },
  {
    id: 2,
    text: "Scale tier set to Fully Autonomous",
    date: "6 days ago",
    user: "Michael L.",
  },
];


function AIPolicies() {
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };



  return (
    <>
      {/* ================= PAGE TITLE ================= */}
      <div className="main_title ai_command_page d_flex">
        <div className="lt">
          <h1>AI Policies, Guardrails & Permissions</h1>
          <p>
            <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
            AI Policies, Guardrails & Permissions
          </p>
        </div>
        <div className="right_s">
          <ButtonGroup aria-label="Basic button group" variant="contained">
            <Button className="auto_pilot" color="primary">
              AI Auto Pilot
            </Button>
            <Button className="off">OFF</Button>
            <Button color="error">Emergency stop</Button>
          </ButtonGroup>
        </div>
      </div>

      <Box className="custom_tabs1 mt_20">
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          className="custom_tabs_links"
        >
          <Tab label="Guardrails" />
          <Tab label="Permissions" />
          <Tab label="Permissions Log" />
          <Tab label="Templates" />

        </Tabs>
      </Box>
      <div className="table_flex mt_20">
        {tabIndex === 0 && (
          <div className="lt">
       <TableContainer className="table_container guardrail_table">
  <Table>
    <TableHead>
      <TableRow>
        <TableCell>Sr. No.</TableCell>
        <TableCell>Guardrail Name</TableCell>
        <TableCell>Affected Modules / Categories</TableCell>
        <TableCell>Severity</TableCell>
        <TableCell>Auto-Pilot</TableCell>
        <TableCell>Actions</TableCell>
      </TableRow>
    </TableHead>

    <TableBody>
      {guardrailRows.map((row, index) => (
        <TableRow key={row.id} hover>
          <TableCell>{index + 1}</TableCell>

          {/* NAME */}
          <TableCell className="name_cell">
            <div className="title">{row.name}</div>
            <div className="desc">{row.desc}</div>
          </TableCell>

          {/* MODULES */}
          <TableCell>
            <div className="module_wrap">
              {row.modules.map((m) => (
                <span key={m} className="module_chip">
                  <span className="shield">🛡</span>
                  {m}
                </span>
              ))}
            </div>
          </TableCell>

          {/* SEVERITY */}
          <TableCell>
            <span
              className={`severity ${
                row.severity === "Critical" ? "critical" : "moderate"
              }`}
            >
              <span className="dot" />
              {row.severity}
            </span>
          </TableCell>

          {/* AUTOPILOT */}
          <TableCell>
            {row.autopilot === "Locked" ? (
              <span className="autopilot locked">
                <LockOutlinedIcon fontSize="inherit" />
                Locked
              </span>
            ) : (
              <span
                className={`autopilot ${
                  row.autopilot === "ON" ? "on" : "off"
                }`}
              >
                {row.autopilot}
                <Switch size="small" checked={row.autopilot === "ON"} />
              </span>
            )}
          </TableCell>

          {/* ACTIONS */}
          <TableCell>
            <IconButton size="small">
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
            <IconButton size="small">
              <MoreHorizOutlinedIcon fontSize="small" />
            </IconButton>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer>


      
          </div>
        )}

        {tabIndex === 1 && 
        <PermissionTables />
        }

        {tabIndex === 2 && 
        <PermissionLogTable />

        }

         {tabIndex === 3 && 
        <TemplateTable />

        }

        <div className="rt">
          <div className="right_panel">
            {/* AI AUTONOMY MATURITY */}
            <div className="maturity_card">
              <h3 className="card_title">AI Autonomy Maturity</h3>

              {maturityLevels.map((item) => (
                <div key={item.id} className="maturity_item">
                  <div className={`level_box level_${item.id}`}>{item.id}</div>
                  <div>
                    <h4>
                      {item.level} <span>{item.title}</span>
                    </h4>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* FILTER & RULE LOG */}
            <div className="rule_card">
              <div className="rule_header">
                <h3>Filter & Rule Log</h3>
                <Button variant="text" size="small">
                  •••
                </Button>
              </div>

              <div className="filter_row form">
                <Select size="small" defaultValue="tier">
                  <MenuItem value="tier">Tier</MenuItem>
                </Select>

                <Select size="small" defaultValue="7days">
                  <MenuItem value="7days">Last 7 Days</MenuItem>
                </Select>
              </div>

              {logs.map((log) => (
                <div key={log.id} className="log_item">
                  <p>
                    <strong>{log.text.split(" ")[0]}</strong>{" "}
                    {log.text.split(" ").slice(1).join(" ")}
                  </p>
                  <span>
                    {log.date} &nbsp; {log.user}
                  </span>
                  <Button
                    variant="text"
                    size="small"
                    style={{ float: "right" }}
                  >
                    •••
                  </Button>
                </div>
              ))}

              <div
                className="view_all"
                style={{ textAlign: "right", marginTop: 10 }}
              >
                <Button variant="text" size="small" color="primary">
                  View All
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AIPolicies;
